import { put, select, takeEvery } from 'redux-saga/effects';
import { setUserServiceCenter } from '../../actions/userdata-actions';
import { SERVICECENTER_ALL_GET } from '../../actions/utility-actions';
import { AppUser } from '../../models/utilities/app-user';
import { ServiceCenter } from '../../models/utilities/service-center';
import { getCurrentServiceCenter, getCurrentUser } from '../../selectors/userdata-selectors';
import { getAllServiceCenters } from '../../selectors/utility-selectors';

/**
 * Saga for getting the application service centers for the portal
 */
export function* getServiceCenters() {

    const serviceCenterList = (yield select(getAllServiceCenters)) as ServiceCenter[];

    // Set the active service center based on users permissions 
    const activeSc = (yield select(getCurrentServiceCenter)) as ServiceCenter;
    const user = (yield select(getCurrentUser)) as AppUser;

    // The one chosen last time stays, unless the user can not work there any more
    const stillAllowed = !user || !user.serviceCenters || user.serviceCenters.length === 0 || AppUser.canWorkIn(user.serviceCenters, activeSc ? activeSc.name : undefined);
    if (activeSc && stillAllowed) {
        return;
    }
    else {

        // Otherwise the first the user can work in
        if (user && user.serviceCenters) {
            const tmp = user.serviceCenters[0];

            // !! tmp will be the name of the service like "ALL", not an ID !!
            if (tmp) {

                const selected = serviceCenterList.find((itm: ServiceCenter) => {
                    return itm.name === tmp;
                });

                if (selected) {
                    yield put(setUserServiceCenter(selected));
                }
            }
        }
    }
}

export function* getServiceCentersWatcher() {
    yield takeEvery(SERVICECENTER_ALL_GET, getServiceCenters);
}
